import {
  nostoCollectionQuery,
  nostoSearchQuery,
  renderNostoCollectionResults,
  showProductCount,
  renderSort,
  renderNostoCollectionFacets,
  updateQueryWithFilterAndSort,
  nostoCollectionAnalytics,
  paginationUI
} from "./nosto-functions.js";

(() => {


  // hide product count
  document.getElementById('products-count').style.display = 'none';

  const pageLimit = nostoProductsPerPage;
  const url = new URL(window.location);

  let SEARCH = false;
  let SEARCH_QUERY = '';
  let SEARCH_SESSION_PARAMS = null;

  if (url.searchParams.get('q')) {
    SEARCH_QUERY = url.searchParams.get('q');
    SEARCH = true;
  }


  if (SEARCH) {
    let interval,
      counter = 0,
      duration = 100,
      limit = 80;
    interval = setInterval(() => {
      if (typeof nostojs != 'undefined') {
        //console.log('nostojs found')
        //console.log(counter)

        nostojs(api => {
          api.getSearchSessionParams()
            .then(response => {
              //let searchSessionParams = response;
              SEARCH_SESSION_PARAMS = response;
              //getNostoSearchResults(params.q, searchSessionParams);
              getNostoCollectionResults();
              api.recordSearchSubmit(SEARCH_QUERY)
            });
        })

        clearInterval(interval);
      } else if (counter === limit) {
        clearInterval(interval);
      }
      counter++;
    }, duration);

  } else {
    // when true nosto is only used for filters and sort on collections
    getNostoCollectionResults();
  }


  function getNostoCollectionResults(pagination = false) {

    let query = '';
    let variables = {}

    if (SEARCH) {
      query = updateQueryWithFilterAndSort(nostoSearchQuery());
      variables = {
        query: SEARCH_QUERY,
        sessionParams: SEARCH_SESSION_PARAMS
      };
    } else {
      query = updateQueryWithFilterAndSort(nostoCollectionQuery());
      variables = {
        categoryId: collectionId,
        //currencyCode: "EUR",
      }

    }

    const url = new URL(window.location);
    if (url.searchParams.size == 0) {
      const sessionResult = sessionStorage.getItem("nosto-ecom-collection-" + collectionId)
      if (sessionResult) {
        const result = JSON.parse(sessionResult);

        console.log('use nosto session storage')

        render(result, pagination);

        // begin analytics
        //getNostoCollectionAnalytics(result, collectionPath)


        return;

      }
    }


    fetch('https://search.nosto.com/v1/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: query,
        variables: variables,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log('nosto result')
        console.log(result)

        render(result, pagination);

        // begin analytics
        //nostoCollectionAnalytics(result, collectionPath)

        // store results in session storage
        if (!SEARCH) {
          if (!sessionStorage.getItem("nosto_ecom_collection_" + collectionId)) {
            sessionStorage.setItem("nosto-ecom-collection-" + collectionId, JSON.stringify(result))
            console.log('result saved in session storage')
          }
        }


      })
  }

  function render(result, pagination) {
    const url = new URL(window.location);

    let page = 1;
    if (url.searchParams.has('page')) {
      page = Number(url.searchParams.get('page'));
    }

    let hits = result.data.search.products.hits;
    //let hits = result.data.search.products.hits.filter(hit => hit.tags1.some(tag => tag.includes('mvp.')) == false);
    //let rejectedHits = result.data.search.products.hits.filter(hit => hit.tags1.some(tag => tag.includes('mvp.')) == true);

    //console.log('rejectedHits', rejectedHits)
    //console.log('hits', hits)
    

    // render results - product cards
    renderNostoCollectionResults(
      hits,
      'category',
      page,
      pagination,
      pageLimit,
      () => { paginationUI(page, hits.length, pageLimit, () => { getNostoCollectionResults(true) }) }
    );

    // set product count
    showProductCount(hits.length);

    // render facets
    renderNostoCollectionFacets(result.data.search.products.facets, () => { getNostoCollectionResults() });

    // render sort
    setTimeout(() => {
      renderSort(() => { getNostoCollectionResults() });
    }, 1000)

  }

})();
